import { Button } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import RouteBloc from "../../../bloc/route_bloc";
import Config from "../../../Config";

import "./mrtt_client_screen.css";
import GeneralBloc from "../../../bloc/general_bloc";
import AppTextField from "../../component/app_text_field/app_text_field";
import UtilBloc from "../../../bloc/util_bloc";
import { nricValidation } from "../../component/app_validation";
import ClientBloc from "../../../bloc/client_bloc";
import AppModal from "../../component/app_modal/app_modal";
import AppMobileLoading from "../../dialog/app_mobile_loading";

class ClientAuthentication extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            idNo: null,
            qrExpired: false,
        };
    }

    componentDidMount() {

    }

    getProposalId() {
        return this.props.match.params.itemId;
    }

    handleIdChange(val) {
        //if idtype == ic
        let error = UtilBloc.isNullOrEmpty(val);
        this.setState({ idNo: val, error: error, errorMessage: nricValidation(val) })

    }

    async handleSubmitIdNo() {
        this.setState({ loading: true });
        console.log("see", this.state.idNo, this.getProposalId())
        let result = await ClientBloc.verifyClientID(this.state.idNo, this.getProposalId());
        console.log(result)
        if (result.success && result.data) {
            window.location.replace(
                `/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_otp}/${this.getProposalId()}`
            )
        } else {
            this.setState({
                title: 'Error',
                message: result.message + ' ' +result.data,
                isOpen: true
            })
        }
       
        this.setState({ loading: false });
    }

    loadingContent() {
        return (
            <div style={{ height: "100%"}}>
                <AppMobileLoading isLoading={this.state.loading} />
            </div>
        );
    }

    renderAuthentication() {
        return (
            <>
                <div className="d-flex justify-content-center p-4 row w-100 m-0">
                    <img
                        src={
                            GeneralBloc.getAssetsContextPath() +
                            `/assets/images/Illustration/Identity.png`
                        }
                        alt="Documents"
                        className=""
                        style={{ width: 223, height: 170 }}
                    />
                    <div className="client_instruction_text">
                        Please enter the ID Number provided in the proposal to verify your identity
                    </div>
                    <div >
                        <AppTextField
                            type={'text'}
                            placeholder={'Enter your ID number...'}
                            value={this.state.idNo}
                            onChange={(e) => this.handleIdChange(e)}
                            error={this.state.error}
                            errorMessage={this.state.errorMessage}
                        />
                    </div>
                </div>
                <div className="bottom_container d-flex justify-content-center">
                    <Button
                        disable={UtilBloc.nricValidation(this.state.idNo)}
                        style={{
                            backgroundColor: '#183028',
                            color: 'white',
                            width: '100%',
                            height: 49,
                            opacity: UtilBloc.isNullOrEmpty(this.state.idNo) ? 0.7 : 1
                        }}
                        onClick={() => {!UtilBloc.isNullOrEmpty(this.state.idNo) && this.handleSubmitIdNo()}}
                    >
                        Next
                    </Button>
                </div>
            </>
        )
    }

    qrExpired() {
        return (
            <>
                <div className="d-flex justify-content-center p-4 row w-100 m-0">
                    <img
                        src={
                            GeneralBloc.getAssetsContextPath() +
                            `/assets/images/Illustration/QR_Expired.png`
                        }
                        alt="Documents"
                        className=""
                        style={{ width: 335, height: 187 }}
                    />
                    <div className="client_instruction_text">
                        <div style={{ fontWeight: '600', fontSize: 16 }}>QR Code Expired</div>
                        <div className="mt-2" >QR Code is expired. Please contact  your Sales Representative.</div>
                    </div>
                </div>
            </>
        )
    }

    showMessageModal = () => {
        return (
            <AppModal
                open={this.state.isOpen}
                handleModalClose={() => this.setState({ isOpen: false })}
                width={'50%'}
                title={this.state.title}
                subtitle={this.state.message}
                positiveButtonText={'Close'}
                handlePositivePress={() => this.setState({ isOpen: false })}
                closable={false}
            />
        )
    }

    render() {
        return (
            <div className="client_container" style={{ height: '100%' }}>
                 {this.state.loading && this.loadingContent()}
                <div className="mobile_container justify-content-center" style={{ height: window.innerHeight }}>
                    <div className="client_header">
                        {
                            this.state.qrExpired ?
                                'QR Code Expired' : 'Authentication'
                        }
                    </div>
                    {
                        this.state.qrExpired ?
                            this.qrExpired() : this.renderAuthentication()
                    }
                    {this.showMessageModal()}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
});

export default withRouter(connect(mapStateToProps)(ClientAuthentication));
